import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import format from "date-fns/format";
import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

import { ProgressData } from "@/models/progressGraph";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, TimeScale, Title, Tooltip, Legend);

type Props = {
  progressData: ProgressData[];
};

export const ProgressGraph = ({ progressData }: Props) => {
  const { t } = useTranslation();
  const data = useMemo(() => {
    const labels: string[] = [];
    const schedule: number[] = [];
    const result: number[] = [];
    const today = new Date();
    const tomorrow = format(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1), "yyyy-MM-dd");
    for (const d of progressData) {
      labels.push(d.date);
      schedule.push(d.schedule_progress_rate);
      // 実績は本日までのデータを表示する
      d.date < tomorrow && result.push(d.result_progress_rate);
    }

    return {
      labels,
      datasets: [
        // 予実の表示線の重なり順は、実績のほうを上にする
        {
          label: t("results"),
          data: result,
          borderColor: "rgb(255, 99, 132)",
          backgroundColor: "rgba(255, 99, 132, 0.5)",
        },
        {
          label: t("schedule"),
          data: schedule,
          borderColor: "rgb(53, 162, 235)",
          backgroundColor: "rgba(53, 162, 235, 0.5)",
        },
      ],
    };
  }, [progressData]);

  return (
    <div className="bg-white w-full h-full">
      <Line
        height={"100%"}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              max: 100,
              min: 0,
            },
            x: {
              type: "time",
              time: {
                parser: "YYYY-MM-DDTHH:mm:ss.SSSSSSZ",
                tooltipFormat: "YYYY-MM-DD",
                unit: "day",
                displayFormats: {
                  day: "MM/DD",
                },
              },
              ticks: {
                autoSkip: false,
                stepSize: 1,
                color: function (context) {
                  return context.index % 5 === 0 ? "#878787" : "#ffffff";
                },
              },
            },
          },
          plugins: {
            legend: {
              position: "top" as const,
              onClick: (e) => e.native.stopPropagation(),
            },
            title: {
              display: false,
            },
          },
        }}
        data={data}
      />
    </div>
  );
};
